<template>
    <!-- Corporate vertical has no copyright footer. -->
    <div v-if="!isCorporate" class="tw:pt-6 tw:pb-4 tw:mt-auto tw:flex tw:justify-center">
        <span>Copyright {{ currentYear }} Edverum. All rights reserved.</span>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { isCorporateClient } from '@/composables/useEdverumClient.js';
import moment from '@/plugins/vue-moment.js';

const isCorporate = isCorporateClient();

const currentYear = computed(() => {
    return moment().year();
});
</script>
